import { InputJson } from "nq-component";
import HrddForApprovalFormPresenter from "./HrddForApprovalFormPresenter";
import BaseFormPage from "../../../../../base/BaseFormPage";
import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import NavBar from "../../../../../components/navigation";
import FormFactory from "../../../../../components/FormFactory";
import FileUpload from "../../../../../components/common/FileUpload";
import withRouter from "../../../../../withRouter";
import InputFactory from "../../../../../components/InputFactory";

class HrddForApprovalFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.presenter = new HrddForApprovalFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
    );
    this.state = {
      object: {},
      employeeName: "",
      advanced: false,
      type: [],
      selectedType: "",
      leaves: [],
    };
    // this.presenter = new CollectionFormPresenter(
    //   this,
    //   getObjectUseCase(),
    //   upsertUseCase()
    // );
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const type = await findObjectUseCase().execute("leave_type");
    console.warn("type: ", type);
    this.setState({ type });
  }
  async componentDidUpdate(prevProps, prevState) {
    const { object } = this.state;
    if (prevState.object !== object) {
      const employeeName = `${object?.employee?.Firstname || ""} ${
        object?.employee?.Middlename || ""
      } ${object?.employee?.surname || ""}`;

      const leaves = await findObjectUseCase().execute("leave_cred", {
        where: {
          empID: object.employee.id,
        },
      });
      this.setState({
        employeeName,
        selectedType: object.selectedType,
        leaves,
      });
    }
  }

  getCollectionName() {
    return "leave_request";
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  onChangeForm(field, value) {
    this.setState({ [field]: value });
  }

  async handleApproveBtn() {
    this.presenter.DialogConfirmation("Approved");
  }

  // handleRejectBtn() {
  //   this.presenter.DialogConfirmation("Rejected");
  // }

  handleApproveWithoutPay() {
    this.presenter.DialogConfirmation("Disapproved");
  }

  render() {
    const object = this.state.object;
    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-3 text-capitalize">
                {(schema.label || this.getCollectionName()) + " Details"}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.handleApproveBtn();
                  }}
                >
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChangeObject.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <>
                        <div className="d-grid">
                          <label>
                            <b>Employee Name: </b>
                            {this.state.employeeName}
                          </label>
                          <label>
                            <b>Half Day: </b>
                            {this.state.object.halfday ? "Yes" : "No"}
                          </label>
                        </div>
                        <FormFactory
                          // disabled={object.stats !== "Approved"}
                          schema={schema}
                          object={object}
                          disabled={true}
                          onChange={this.onChange.bind(this)}
                          excludeFields={[
                            "selectedType",
                            "halfDay",
                            "employee",
                            "workingDays",
                            "selectedFiles",
                            "selectedLeave",
                            "creditDeduction",
                            "stats",
                            ...(object.halfDay ? ["enddate"] : []),
                          ]}
                        />

                        <div className="mb-2">
                          <label className="mb-2 fs-6">Attachments</label>
                          <br></br>
                          <InputFactory
                            type="File"
                            onChange={(value) =>
                              this.onChangeForm("selectedFiles", value)
                            }
                            disabled={true}
                            value={object.selectedFiles}
                            className="form-control"
                          />
                        </div>
                        <div className="border">
                          <h6 className="border-bottom p-2 fw-semibold">
                            Leave Summary
                          </h6>
                          <div className="border-bottom p-2 pb-0">
                            <h6 className="fw-semibold">Leave Credits</h6>
                            {this.state.leaves.map((item) => {
                              return (
                                <>
                                  <p>{`${item.type}: ${item.current}`}</p>
                                </>
                              );
                            })}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="mt-4">
                    {object.stats === "For HRMS Processing" && (
                      <>
                        <button
                          type="submit"
                          className="btn btn-primary fs-sm me-3"
                        >
                          <i className="bi bi-file-earmark-check me-2"></i>
                          Approve
                        </button>

                        <button
                          type="button"
                          onClick={this.handleApproveWithoutPay.bind(this)}
                          className="btn btn-danger fs-sm me-3"
                        >
                          <i className="bi bi-file-earmark-check me-2"></i>
                          Disapprove
                        </button>
                        {/* )} */}

                        {/* <button
                          type="button"
                          className="btn btn-danger fs-sm me-3"
                          onClick={() => this.handleRejectBtn()}
                        >
                          <i className="bi bi-x-square me-2"></i>
                          Reject
                        </button> */}
                      </>
                    )}
                    <button
                      type="button"
                      className="btn btn-light fs-sm"
                      onClick={this.onClickBack.bind(this)}
                    >
                      GO BACK
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(HrddForApprovalFormPage);
